import { Component } from '@angular/core';

@Component({
  selector: 'pdf-comment-manager-dialog',
  templateUrl: './pdf-comment-manager-dialog.component.html',
  standalone: false,
})
export class PdfCommentManagerDialogComponent {}
